module.exports = "<reusable-modal \n  title=\"{{$ctrl.title}}\"\n  on-accept=\"$ctrl.save()\"\n  on-cancel=\"$ctrl.cancel()\"\n  accept-button-text=\"Save\"\n  cancel-button-text=\"Cancel\"\n  accept-disabled=\"!$ctrl.isFeeTypeFormValid\"\n  is-loading=\"$ctrl.isLoading\">\n\n  <fee-type-form\n    fee-type=\"$ctrl.feeType\"\n    on-valid-change=\"$ctrl.onFormValidChange(isValid)\">\n  </fee-type-form>\n\n</reusable-modal>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/fees/feeTypeManagement/addFeeTypeDialog/addFeeType.dialog.html
// module id = 1189
// module chunks = 0